import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { IdentityCommonService } from '@identity/identity-common.service';

const HOMEPAGE = '/';
const AUTH_NOT_LOGGED_ROUTES: Array<string> = ['signIn', 'signup', 'forgot-password', 'reset-password'];
const AUTO_LOGIN_ROUTES: Array<string> = ['embedded'];

export const authGuard: CanActivateFn = (route, state) => {
    const identityCommonService = inject(IdentityCommonService);
    const router = inject(Router);
    if (AUTH_NOT_LOGGED_ROUTES.includes(route.url[0].path) && !identityCommonService.isLogged()) {
        return true;
    }
    else if (AUTO_LOGIN_ROUTES.includes(route.url[0].path) && !identityCommonService.isLogged()) {
        var token = route.queryParams["token"];
        if (token !== undefined) {
            return new Promise((resolve) => {
                identityCommonService.autologin(token).then((response) => {
                    resolve(response);
                }).catch(() => {
                    resolve(false);
                })
            })
        }
        else {
            return false;
        }
  }
  else if (!AUTH_NOT_LOGGED_ROUTES.includes(route.url[0].path) && identityCommonService.isLogged()) {
      return true;
  }
  else {
    router.navigate([HOMEPAGE]);
    return false;
  }
};
